import { useState } from "react";
import { dataProvider } from "data";
import { apiMethods } from "data/api.constants";
import { useRefresh } from "react-admin";
import { useNotifications } from "utils/hooks/useNotifications";

export const useRefreshStats = () => {
  const [loading, setLoading] = useState(false);
  const { notify } = useNotifications();
  const refresh = useRefresh();

  const handleRefreshStats = async ({
    isWhatsApp,
    campaignUuid,
    onSuccess,
  }) => {
    if (!campaignUuid) return;

    setLoading(true);
    const endpoint = isWhatsApp
      ? "notifications/refresh/whatsapp/campaign"
      : "notifications/refresh/email/campaign";

    try {
      const response = await dataProvider.custom_request(
        endpoint,
        apiMethods.POST,
        { campaign_uuid: campaignUuid }
      );

      if (response) {
        notify("Stats refreshed successfully!", "success");
        refresh();
        if (typeof onSuccess === "function") {
          onSuccess();
        }
      }
    } catch (error) {
      console.error("Error refreshing stats:", error);
      notify("Failed to refresh stats. Please try again.", "error");
    } finally {
      setLoading(false);
    }
  };

  return { handleRefreshStats, loading };
};
